<div class="flex column toasters" data-testid="toaster">
	<div class="flex space-between w-100 center">
		<div class="flex gap-8 center" >
			<mat-icon [svgIcon]="iconType"></mat-icon>
			<span [ngStyle]="{'color': color}" >{{data?.message | translateWithKeys:{ params: data?.interpolationParams } }}</span>
		</div>
		<div class="gap center">
			@if(data?.buttons){
			<div class="flex gap-8">
				<button class="blue-btn pointer">
					<!-- TODO: no design for name of button yet -->
					<span class="title2">
						Button
					</span>
				</button>
				<button class="white-btn pointer">
					<!-- TODO: no design for name of button yet -->
					<span class="title2 ">
						Button
					</span>
				</button>
			</div>
			}
			<div class="flex center">
				<mat-icon svgIcon="close-grey" class="close-icon pointer" (click)="closeSnackBar()"></mat-icon>
			</div>
		</div>
	</div>
	@if (data?.description) {
	<div class="description">
		<span class="description">{{data?.description | translateWithKeys }}</span>
	</div>
	}
</div>
